import React, { useEffect, useState } from 'react';
import LocationsLayout from './LocationsLayout/LocationsLayout';
import { Skeleton, Stack } from '@mui/material';
import StructureListItem from './StructureListItem';
import useTypeEntity from './useTypeEntity';
import useWatchError from '../../../../../shared/hooks/useWatchError';
import ManagerViewStore from '../ManagerViewStore/ManagerViewStore';
import { M_SECONDS_POOLING_INTERVAL_DATA } from '../../../../../service/store/Store.constants';
import useDevicesManager from '../../../../../service/device/hooks/useDevicesManager';
import WorkspaceDashboard from '../../../WorkspaceAdmin/WorkspaceAdminList/WorkspaceDashboard';
import { BusinessLayerGroupType } from '../../../../../redux/structure/util/getTypeFromGroup';

function EntityBusinessLayerList() {
  const {
    type,
    filteredChildGroups,
    groupId: storeId,
    error: errorEntity,
    role,
    entity,
    marketId,
  } = useTypeEntity({
    refetchOnMountOrArgChange: true,
    pollingInterval: M_SECONDS_POOLING_INTERVAL_DATA,
  });

  const {
    data: devices,
    error: devicesError,
    isLoading: devicesLoading,
  } = useDevicesManager(storeId, {
    skip: !storeId || type !== 'store',
    refetchOnMountOrArgChange: true,
    pollingInterval: M_SECONDS_POOLING_INTERVAL_DATA,
  });

  const error = devicesError || errorEntity;
  useWatchError(error);
  const content =
    type !== 'store' ? (
      <Stack spacing={1}>
        {filteredChildGroups?.map((entity: any) => (
          <StructureListItem key={entity?.id} entity={entity} />
        ))}
      </Stack>
    ) : (
      <>
        <ManagerViewStore devices={devices} />
        {devicesLoading && !devices.length && (
          <Skeleton variant="rectangular" width={'100%'} height={200} />
        )}
      </>
    );

  // use effect to simulate the animation
  const [showRightPanel, setShowRightPanel] = useState(false);
  useEffect(() => {
    const current = Boolean(
      (marketId && !entity) ||
        (entity &&
          type !== BusinessLayerGroupType.Store &&
          type !== BusinessLayerGroupType.Unknown)
    );
    if (current !== showRightPanel) {
      setShowRightPanel(current);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [marketId, entity, type]);

  return (
    <LocationsLayout
      innerContainerMaxWidth={
        type === BusinessLayerGroupType.Store ? 'xl' : 'lg'
      }
      role={role}
      showRightPanel={showRightPanel}
      rightPanel={<WorkspaceDashboard workspaceId={marketId ?? ''} />}
    >
      {content}
    </LocationsLayout>
  );
}

export default EntityBusinessLayerList;
